import { Trans } from 'react-i18next'

import kidneysFiltrationPNG from '~/assets/images/anatomy/kidneys-filtration.png'
import kidneysFiltrationWEBP from '~/assets/images/anatomy/kidneys-filtration.webp'
import {
  ANSWERS,
  KIDNEYS_FILTRATION_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/anatomy/quizBinaryChoice/libs/styles'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const KidneysFiltration = ({ pageId, nextPagePath }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: KIDNEYS_FILTRATION_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <PS.Question>
          <Trans i18nKey="onboarding.quizBinaryChoice.kidneysFiltrationQuestion" />
        </PS.Question>

        <PS.ImageWrapper>
          <picture>
            <source srcSet={kidneysFiltrationWEBP} type="image/webp" />
            <img src={kidneysFiltrationPNG} alt="Kidneys & Filtration" />
          </picture>
        </PS.ImageWrapper>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default KidneysFiltration
